import React from "react";

export function ComplianceScoreRing({ score }) {
  const radius = 42;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (score / 100) * circumference;
  const color = score >= 80 ? "#16a34a" : score >= 50 ? "#d97706" : "#dc2626";

  return (
    <div className="relative w-28 h-28 flex items-center justify-center" data-testid="compliance-score-ring">
      <svg width="112" height="112" viewBox="0 0 112 112" className="-rotate-90">
        <circle cx="56" cy="56" r={radius} stroke="#e2e8f0" strokeWidth="8" fill="none" />
        <circle cx="56" cy="56" r={radius} stroke={color} strokeWidth="8" fill="none" strokeLinecap="round"
          strokeDasharray={circumference} strokeDashoffset={offset} style={{ transition: "stroke-dashoffset 0.5s ease" }} />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="text-2xl font-bold" style={{ color, fontFamily: "'Outfit', sans-serif" }}>{score}%</span>
        <span className="text-[10px] text-slate-500 uppercase tracking-wide">Compliant</span>
      </div>
    </div>
  );
}

export const statusColors = {
  upcoming: "bg-blue-100 text-blue-700", in_progress: "bg-amber-100 text-amber-700",
  completed: "bg-emerald-100 text-emerald-700", overdue: "bg-red-100 text-red-700",
  breached: "bg-red-200 text-red-800", met: "bg-emerald-100 text-emerald-700",
  not_met: "bg-red-100 text-red-700",
};

export const complianceStatusColors = {
  compliant: "bg-emerald-100 text-emerald-700", non_compliant: "bg-red-100 text-red-700",
  pending_review: "bg-slate-100 text-slate-600",
};

export const priorityColors = {
  low: "bg-slate-100 text-slate-600", medium: "bg-blue-100 text-blue-700",
  high: "bg-amber-100 text-amber-700", critical: "bg-red-100 text-red-700",
};
